<mat-sidenav-container class="sidenav-container"
                       (backdropClick)="onClickBackdrop()">
    <ng-content select="gipi-sidenav"> </ng-content>

    <div [class.small-container]="((isScreenLarge | async) && (isExpanded | async))"
         [class.large-container]="!((isScreenLarge | async) && (isExpanded | async))"
         (click)="onClickBackdrop()">
        <ng-content> </ng-content>
    </div>
</mat-sidenav-container>